import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {bindActionCreators} from 'redux';
import {connect} from 'store';
import {
    toggleDownload,
    downloadTranscript,
    setTranscriptFormat,
    setCaptionFormats,
    setCaptionFormat,
    downloadCaptions,
} from 'store/ui/actions';
import Dialog from 'components/layout/dialog';
import {Section, Field, Select} from 'components/forms';

export class Download extends Component {
    static propTypes = {
        opened: PropTypes.bool,
        captions: ImmutablePropTypes.map,
        language: PropTypes.string.isRequired,
        transcriptFormat: PropTypes.string,
        transcriptFormats: ImmutablePropTypes.list,
        captionFormat: PropTypes.string,
        captionFormats: ImmutablePropTypes.list,
        toggleDownload: PropTypes.func.isRequired,
        downloadTranscript: PropTypes.func.isRequired,
        downloadCaptions: PropTypes.func.isRequired,
        setCaptionFormats: PropTypes.func.isRequired,
        setCaptionFormat: PropTypes.func.isRequired,
        setTranscriptFormat: PropTypes.func.isRequired,
    };

    componentWillMount() {
        this.props.setCaptionFormats(this.props.language, this.props.captions);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.opened !== this.props.opened
            || nextProps.captions !== this.props.captions
            || nextProps.language !== this.props.language
            || nextProps.captionFormat !== this.props.captionFormat
            || nextProps.captionFormats !== this.props.captionFormats;
    }

    render() {
        return (
            <div className='cielo24-vwrap-download'>
                <button
                    type='button'
                    className='cielo24-vwrap-toggle'
                    title={i18next.t('Download')}
                    aria-label={i18next.t('Download')}
                    onClick={this.props.toggleDownload}
                >
                    <i className='cielo24-vwrap-icon cielo24-vwrap-icon-download' aria-hidden={true} />
                </button>
                <Dialog title={i18next.t('Download')} opened={this.props.opened} onClose={this.props.toggleDownload}>
                    <Section title={i18next.t('Transcript')}>
                        {this.props.transcriptFormats.size ? (
                            <div>
                                <Field label={i18next.t('Format')}>
                                    <Select
                                        value={this.props.transcriptFormat}
                                        options={this.props.transcriptFormats}
                                        onChange={this.props.setTranscriptFormat}
                                    />
                                </Field>
                                <Field>
                                    <button
                                        className='cielo24-vwrap-download-button'
                                        onClick={this.props.downloadTranscript}
                                    >
                                        Download
                                    </button>
                                </Field>
                            </div>
                        ) : (
                            <Field>
                                {i18next.t('There is no transcript available for the current language.')}
                            </Field>
                        )}
                    </Section>
                    <Section title={i18next.t('Captions')}>
                        {this.props.captionFormats.size ? (
                            <div>
                                <Field label={i18next.t('Format')}>
                                    <Select
                                        value={this.props.captionFormat}
                                        options={this.props.captionFormats}
                                        onChange={this.props.setCaptionFormat}
                                    />
                                </Field>
                                <Field>
                                    <button
                                        className='cielo24-vwrap-download-button'
                                        onClick={this.props.downloadCaptions}
                                    >
                                        Download
                                    </button>
                                </Field>
                            </div>
                        ) : (
                            <Field>
                                {i18next.t('There are no captions available for the current language.')}
                            </Field>
                        )}
                    </Section>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    opened: state.ui.get('downloadOpened'),
    captions: state.captions.get('urls'),
    language: state.config.get('language'),
    transcriptFormat: state.ui.get('downloadTranscriptFormat'),
    transcriptFormats: state.ui.get('downloadTranscriptFormats'),
    captionFormat: state.ui.get('downloadCaptionFormat'),
    captionFormats: state.ui.get('downloadCaptionFormats'),

});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    toggleDownload,
    downloadTranscript,
    downloadCaptions,
    setCaptionFormats,
    setCaptionFormat,
    setTranscriptFormat,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Download);



// WEBPACK FOOTER //
// ./scripts/components/footer/download.js